import React, { useState, useEffect } from "react";
import MasterTable from "../common/MasterTable";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import Loader from "../Loader/Loader";
import AddCourierMasterModal from "./AddCourierMasterModal";
import { format, parse } from "date-fns";
import CourierFilterModal from "./CourierFilterModal";
import { formatDateToYYYYMMDD } from "../../helpers/DateHelpers";
import { useDispatch } from "react-redux";
import { setBalance } from "../store/balance/balanceSlice";
import HeaderWithBreadcrumb from "../common/HeaderWithBreadcrumb";

const defaultFilterData = {
  companyId: "",
  retailerCode: "",
  pincode: "",
  fromDate: "",
  toDate: "",
  status: [],
};

const CourierMaster = () => {
  // const pageSize = 10;
  const [pageSize, setPageSize] = useState(10);
  const [noData, setNoData] = useState(false);
  const [editData, setEditData] = useState({});
  const [customerData, setCustomerData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(false);
  const [pageDetails, setPageDetails] = useState(null);
  const loggedInUserName = sessionStorage.getItem("username");
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [columnData, setColumnData] = useState("");

  const dispatch = useDispatch();

  const [isModalOpenCreate, setIsModalOpenCreate] = useState(false);
  const openModalCreate = () => {
    setIsModalOpenCreate(true);
  };

  const closeModalCreate = () => {
    setIsModalOpenCreate(false);
  };

  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  useEffect(() => {
    fetchCourierData(1);
  }, []);

  const fetchDashboardData = () => {
    const endDate = formatDateToYYYYMMDD(new Date());
    const startDate1 = new Date(new Date().setDate(new Date().getDate() - 90));
    const finalStartDate = formatDateToYYYYMMDD(startDate1);

    const requestBody = {
      startDate: finalStartDate,
      endDate: endDate,
      username: loggedInUserName,
    };

    axiosPostApi(apiList.DASHBOARD_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          dispatch(setBalance(response?.data?.data));
        }
      })
      .catch((error) => {
        console.error("Error fetching SMS overview data", error);
      });
  };

  const fetchCourierData = async (
    currentPage,
    filters = filterData,
    size = pageSize
  ) => {
    setLoading(true);

    try {
      const requestBody = {
        username: loggedInUserName,
        companyId: filters.companyId || "",
        retailerCode: filters.retailerCode || "",
        pincode: filters.pincode || "",
        fromDate: filters.fromDate || "",
        toDate: filters.toDate || "",
        status: filters.status || [],
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_COURIER_MASTER_DATA}?&pageSize=${size}&pageNo=${currentPage}`,
        requestBody
      );
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setLoading(false);
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setCustomerData(modifiedData);
        fetchDashboardData();
        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setLoading(false);
        setNoData(true);
        setCustomerData([]);
      }
    } catch (error) {
      setLoading(false);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return response?.map((user, index) => {
      const formattedCreDate = user?.createdDate
        ? parse(user.createdDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;
      const addressComponents = [
        user.address1,
        user.address2,
        user.address3,
        user.pincode,
        user.city,
        user.state,
        user.country,
      ].filter((component) => component != null && component !== "");
      const address =
        addressComponents.length > 0 ? addressComponents.join(", ") : "";

      return {
        ...user,
        address,
        createdDate: formattedCreDate
          ? [
              format(formattedCreDate, "dd-MM-yyyy"),
              <br key={index} />,
              format(formattedCreDate, "HH:mm:ss"),
            ]
          : "",
      };
    });
  };

  const customerHeader = [
    "Company Id",
    "Company Name",
    "Retailer Code",
    "Retailer Name",
    "Status",
    "Remark",
    "Authorised Person Name",
    "Authorised Person Mobile No",
    "Authorised Person Email Id",
    "Address",
    "Created Date",
    "Created By",
  ];

  const customerHeaderToKeyMap = {
    "Company Id": "companyId",
    "Company Name": "companyName",
    "Retailer Code": "retailerCode",
    "Retailer Name": "retailerName",
    Status: "status",
    Remark: "adminRemark",
    "Authorised Person Name": "authPersonName",
    "Authorised Person Mobile No": "authPersonMobile",
    "Authorised Person Email Id": "authPersonEmail",
    Address: "address",
    "Created Date": "createdDate",
    "Created By": "createdBy",
  };

  const handleAuthorization = (data, actionType = "view") => {
    setModalAction(actionType);
    setColumnData(data);
    let custData = customerData.find((item) => item?.id === data?.id);
    if (custData) {
      setEditData(custData);
      setIsModalOpenCreate(true);
    }
  };

  const handleCustomer = (data, actionType = "view") => {
    setModalAction(actionType);
    setColumnData(data);
    if (actionType === "add") {
      setEditData({});
      openModalCreate(true);
    } else if (actionType === "auth") {
      let custData = customerData.find((item) => item?.id === data?.id);
      if (custData) {
        setEditData(custData);
        setIsModalOpenCreate(true);
      }
    } else {
      let custData = customerData.find((item) => item?.id === data?.id);
      if (custData) {
        setEditData(custData);
        openModalCreate(true);
      }
    }
  };

  const handleCourier = (authData) => {
    CustomAlert({
      title: "Courier Key",
      text: authData?.courierServiceKey || "No courier service key available",
      icon: "info",
      confirmButtonText: "Okay",
    });
  };

  const handleReset = () => {
    setFilterData(defaultFilterData);
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <>
      <HeaderWithBreadcrumb title="Courier Master" breadcrumb="Master" />
      <div>
        <div className="bg-[#FFFFFF] shadow-custom rounded-[14px] px-[10px]">
          {loading ? (
            <Loader />
          ) : (
            <>
              <MasterTable
                loading={loading}
                headers={customerHeader}
                data={customerData}
                handleAction={handleCustomer}
                filterFields={["companyName"]}
                entityType="Courier"
                headerToKeyMap={customerHeaderToKeyMap}
                handleAuth={handleAuthorization}
                noData={noData}
                pageDetails={pageDetails}
                currentPage={currentPage}
                pageSize={pageSize}
                // pageSize={pageSizeCount}
                totalRecord={totalRecord}
                // fetchNextData={fetchCourierData}
                // fetchNextData={(page, size) => fetchCourierData(page, filterData, size)}
                fetchNextData={(page, filters = filterData, size) =>
                  fetchCourierData(page, filters, size)
                }
                setCurrentPage={setCurrentPage}
                setPageSize={setPageSize}
                openModalFilter={openModalFilter}
                handleReset={handleReset}
                filterData={filterData}
                // fetchData={() => fetchCourierData(1)}
                fetchData={() =>
                  fetchCourierData(1, defaultFilterData, pageSize)
                }
                CourierKey={handleCourier}
              />
            </>
          )}

          {isModalOpenCreate ? (
            <AddCourierMasterModal
              show={isModalOpenCreate}
              handleClose={closeModalCreate}
              editData={editData}
              action={modalAction}
              callApi={fetchCourierData}
              columnData={columnData}
            />
          ) : null}

          {isModalOpenFilter ? (
            <CourierFilterModal
              show={isModalOpenFilter}
              handleClose={closeModalFilter}
              setCustomerData={setCustomerData}
              setPageDetails={setPageDetails}
              setNoData={setNoData}
              currentPage={currentPage}
              pageSize={pageSize}
              filterData={filterData}
              setFilterData={setFilterData}
              handleReset={handleReset}
              defaultFilterData={defaultFilterData}
            />
          ) : null}
        </div>
      </div>
    </>
  );
};

export default CourierMaster;
